import React, {useEffect, useState} from 'react';
import FinishTick from '../../Assets/SVG/FinishTickDynamica';
import {isMobile} from 'react-device-detect';
import BtnWhiteBlackBorderBigSize from '../../../../Shared/Buttons/BtnWhiteBlackBorderBigSize';
import {buildUrlAndOpenSameWindow} from '../../../../../utilities/StringHelpers/StringHelpers';
import Config from '../../../../../Config';

const ActiveScreen = (props) => {
  const disclaimerText = isMobile ? (
    <p className='disclaimerText' style={{marginTop: '200px'}}>
      *דינמיקה עושה את מירב המאמצים לספק את המידע <br />
      המעודכן והאמין ביותר, אך הוא נועד לנוחות בלבד ואינו <br />
      מובטח כמדויק בכל עת. על מנת לבדוק אם מכשירך מתאים <br />
      ועומד ביכולות דור 4/5, עליך לוודא זאת מול יצרן המכשיר.
    </p>
  ) : (
    <p className='disclaimerText' style={{marginTop: '200px'}}>
      *דינמיקה עושה את מירב המאמצים לספק את המידע המעודכן והאמין <br />
      ביותר, אך הוא נועד לנוחות בלבד ואינו מובטח כמדויק בכל עת. על מנת <br />
      לבדוק אם מכשירך מתאים ועומד ביכולות דור 4/5, עליך לוודא זאת מול יצרן המכשיר.
    </p>
  );

  return (
    <>
      <FinishTick />
      <div className='headBox'>
        <p className='heading'>
          מעולה,
          <br />
          המכשיר שלך תומך
        </p>
        <p className='subHeading'>עכשיו אפשר ליהנות משיחות{isMobile ? <br /> : null} באיכות גבוהה וחיבור מהיר</p>
      </div>
      {disclaimerText}
    </>
  );
};

export default ActiveScreen;
